module.exports = __webpack_public_path__ + "static/media/sms-default.c315960d.png";